define('views/modules/questionnaire/member/fill-questionnaire-content',[
    // libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/layout',
    'services/i18n',
    'services/toastr-service',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/questionnaire/member/questions-list',
    'src/views/form-view',
    // collections
    'collections/member/supervisors',
    'collections/conversation/conversations',
    // templates
    'text!templates/modules/questionnaire/member/fill-questionnaire-content.html'
], function(
    // libs
    _, Backbone, Mustache, U,
    // services
    LayoutState,
    i18n,
    ToastrService,
    // views
    VMenuSaveAction,
    VQuestionsList,
    VForm,
    // collections
    Supervisors,
    CConversations,
    // templates
    TFillQuestionnaireContent
) {

    var VFillQuestionnaireContent = VForm.extend({
        template: TFillQuestionnaireContent,

        regions: {
            list: '.questions-list',
            menu: ".menu-actions",
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                group: opt.group,
                questionnaire: opt.questionnaire
            });

            var model = this.model,
                conversations = this.conversations = new CConversations(),
                collection = this.collection = model.getQuestions(),
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveButton,
                        saveText: "Send",
                        saveIcon: "fa fa-paper-plane",
                        radio: false,
                        tooltip: {
                            container: this.regions.root,
                        }
                    }),
                    list: new VQuestionsList({
                        model: model,
                        collection: collection,
                    })
                };

            this.listenTo(collection, { 'change': this.onCollectionChange });
            this.listenTo(model, { 'change:_questions': this.onQuestionsChange });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.questionnaire.toJSON())));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.list, zone.$list);

            this.updateSaveButton();

            return this;
        },

        isDirty: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        updateSaveButton: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        sendNotificationToSupervisors: function() {
            var model = this.model;

            Supervisors.each(function(supervisor) {
                this.conversations.add({
                    message: i18n.t("conversation:member_answered_questionnaire_message"),
                    user: supervisor.id,
                    type: 'questionnaireResponse',
                    activity: model.getQuestionnaire() + ":" + model.id
                }, { sort: false });
            }, this);

            this.conversations.bulkCreate({
                success: this.onFeedbackSent,
                context: this
            });

            return this;
        },

        /////////////
        // events ///
        /////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onSubmit: function() {
            this.model.setAnswers()
                .setQuestionnaire(this.questionnaire);
        },

        onSuccess: function() {
            this.sendNotificationToSupervisors();
            ToastrService.success('questionnaire:questionnaire-has-been-sent-success-message');
        },

        onSaveButton: function() {
            this.submit();
        },

        onQuestionsChange: function(model, value) {
            var collection = this.collection;
            collection.reset(value.models);
            this.collectionCopy = collection.toJSON();
        },

        onCollectionChange: function(model) {
            this.updateSaveButton();
        },

    });

    return VFillQuestionnaireContent;

});

